// config.js

const config = {
  apiBaseUrl: "https://bigscreensocial.wearedevelopers.website", // Your API base URL
};

// const config = {
//   apiBaseUrl: "http://localhost:5000", // Your API base URL
// };

export default config;
